import { useEffect, useState } from "react";
import { useInvoice } from "../../../hooks/useInvoice";
import { usePayload } from "../../../hooks/usePayload";
import Input from "../../form-controls/Input";
import PopUp from "../../ui/PopUp";
import PrimaryButton from "../../ui/PrimaryButton";
import VerificationBox from "./VerificationBox";
import { getOTP, processCheckout, verifyMsisdin } from "../../../service/api";
import verified from "../../../assets/images/verified.svg";
import errorImg from "../../../assets/images/error_card.svg";

const MoovForm = () => {
  const {
    invoice,
    getWallet,
    id,
    transID,
    getRedirectionURL,
    setTransID,
    setCurrentStep
  } = useInvoice();
  const { payload, setPayload } = usePayload();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [isMsisdnVerified, setIsMsisdnVerified] = useState(false);
  const [otp, setOtp] = useState("");

  const [notification, setNotification] = useState({
    img: verified,
    title: "",
    text: ""
  });

  const moovStatusMap = {
    0: {
      ok: true,
      message: "OTP sent Successfully"
    },
    4: {
      ok: false,
      message:
        "You are not authorized to perform this transaction! are you sure you are registered?"
    },
    12: {
      ok: false,
      message: "Minimum amount is 100"
    }
  };

  /* 🔁 Reset verification if number changes */
  useEffect(() => {
    setIsMsisdnVerified(false);
    setOtp("");
  }, [payload?.customer_msisdn]);

  const handleChange = (e) => {
    setPayload({ ...payload, [e.target.name]: e.target.value });
  };

  const getOtp = () => {
    getOTP({
      ...payload,
      invoice_id: id,
      payment_processor_id: getWallet("MOOV_MONEY")?.public_id
    })
      .then((response) => {
        if (moovStatusMap[response.response.status]?.ok) {
          setTransID(response.response.trans_id);
          setIsMsisdnVerified(true);
          setCurrentStep(2);
        } else {
          setNotification({
            img: errorImg,
            title: "Payment Pending",
            text:
              moovStatusMap[response.response.status]?.message ??
              "Something went wrong"
          });
          setIsOpen(true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setNotification({
          img: errorImg,
          title: "Payment Pending",
          text: "Your payment is still pending, make sure you have dialed the USSD code & approved the transaction"
        });
        setIsOpen(true);
        setIsLoading(false);
      });
  };

  const performCheckout = (e) => {
    e.preventDefault();
    setIsLoading(true);

    verifyMsisdin({
      customer_msisdn: payload?.customer_msisdn,
      payment_processor_id: getWallet("MOOV_MONEY")?.public_id
    })
      .then((res) => {
        if (res?.response?.valid) {
          getOtp();
        } else {
          setIsLoading(false);
          setNotification({
            img: errorImg,
            title: "Payment Pending",
            text: "Please check your number to complete the payment"
          });
          setIsOpen(true);
        }
      })
      .catch((err) => {
        setNotification({
          img: errorImg,
          title: "Payment Pending",
          text:
            err?.response?.data?.error?.customer_msisdn?.error_string ||
            "An error occurred, please try again"
        });
        setIsOpen(true);
        setIsLoading(false);
      });
  };

  const handleOTPVerify = (e) => {
    setIsLoading(true);
    e.preventDefault();

    // send payload to server
    processCheckout({
      ...payload,
      invoice_id: id,
      otp: otp,
      payment_processor_id: getWallet("MOOV_MONEY")?.public_id,
      trans_id: transID
    })
      .then(
        (res) => {
          setNotification({
            img: verified,
            title: "Payment Successful",
            text: "The payment has been made successfully."
          });
          setIsOpen(true);
          setCurrentStep(3);
          return res;
        },
        (err) => {
          setNotification({
            img: errorImg,
            title: "Payment Unsuccessful",
            text:
              err.response?.message ??
              "The payment did not succeed because something went wrong."
          });
          setIsOpen(true);
          setIsLoading(false);
          return err;
        }
      )
      .then(({ response }) => {
        if (response?.redirect_url) {
          const queryarams = getRedirectionURL({
            transaction_id: response.transaction_id,
            payment_processor: "Moov Money",
            status: response.status === "SUCCESS" ? "true" : "false"
          });
          setTimeout(() => {
            window.location.href = `${response.redirect_url}?${queryarams}`;
          }, 3500);
        }
      });
  };

  return (
    <>
      <form>
        <Input label="Email" fullWidth value={invoice?.email} disabled />

        <Input
          label="Wallet Number"
          fullWidth
          name="customer_msisdn"
          placeHolder="123456"
          type="number"
          value={payload?.customer_msisdn || ""}
          onChange={handleChange}
          prefix={
            <>
              <img className="logo" src="/flag.png" alt="country logo" />
              <span>+226</span>
            </>
          }
        />

        <VerificationBox
          walletName="Moov Money"
          disabled={!isMsisdnVerified}
          otp={otp}
          setOtp={setOtp}
        />

        <div className="text-center">
          <PrimaryButton
            disabled={
              isLoading ||
              (!isMsisdnVerified && !payload?.customer_msisdn) ||
              (isMsisdnVerified && !otp)
            }
            onClick={isMsisdnVerified ? handleOTPVerify : performCheckout}
            text={
              <div className="verify-btn">
                {isLoading && (
                  <img
                    className="btn-loader"
                    src="https://raw.githubusercontent.com/Codelessly/FlutterLoadingGIFs/master/packages/cupertino_activity_indicator_square_medium.gif"
                    alt="Loading"
                  />
                )}
                {isLoading ? "Processing" : isMsisdnVerified ? "Pay" : "Verify"}
              </div>
            }
          />
        </div>
      </form>
      <PopUp
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        img={notification.img}
        title={notification.title}
        text={notification.text}
      />
    </>
  );
};

export default MoovForm;
